module.exports = __webpack_public_path__ + "static/media/foodimg.24f654ea.png";